"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: titleRef,
    isVisible: isTitleVisible
  } = useRevealOnScroll();
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return <section data-section-id="39060" id="project-hero" className="relative min-h-[90vh] w-full overflow-hidden bg-background text-foreground flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background z-10" />
        <div className="h-full w-full bg-cover bg-center bg-no-repeat opacity-40 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/construction_drone_view.png)]" role="img" aria-label="High-resolution drone shot of a construction site" />
      </div>

      {}
      <div className="absolute top-0 right-0 h-full w-2/3 bg-[radial-gradient(ellipse_at_center,_var(--color-ring)_0%,_transparent_70%)] opacity-10 blur-3xl pointer-events-none z-10 mix-blend-multiply translate-x-1/3" />
      
      {}
      <div className="relative z-20 container mx-auto px-4 md:px-6 flex flex-col items-center text-center max-w-4xl">
        
        {}
        <h1 ref={titleRef} className={`font-default font-extrabold text-5xl md:text-7xl lg:text-[4.5rem] leading-[1.1] tracking-tighter mb-6 transition-all duration-1000 ease-[cubic-bezier(0.19,1,0.22,1)] text-primary ${isTitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          Project 1<br className="hidden md:block" />
          <span className="relative inline-block border-b-[4px] border-accent pb-1">
            Engineering Excellence
          </span>
        </h1>

        {}
        <p className={`font-sans text-lg md:text-[1.125rem] text-muted-foreground max-w-2xl mb-10 transition-all duration-1000 delay-200 ease-[cubic-bezier(0.19,1,0.22,1)] ${isTitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          A comprehensive showcase of our architectural innovation and strategic infrastructure development, 
          delivered with precision and visionary craftsmanship.
        </p>

        {}
        <div className={`transition-all duration-1000 delay-400 ease-[cubic-bezier(0.19,1,0.22,1)] ${isTitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="rounded-none px-8 py-6 text-base font-medium border-0 border-l-4 border-ring bg-primary text-primary-foreground shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300">
            <Link to="/ContactPage">
              View Project Details
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full h-px bg-border/50 z-30" />
    </section>;
}